import { z } from 'zod'
import { stringSchema } from './common'

/**
 * A storefront "view" (BOAT-1912): a Key Feature Label promoted in the CMS to a
 * filtered rendering of the club page and fixture pages, entered via
 * `?view=<slug>`. Banner copy is already resolved to the site locale.
 */
export const storefrontViewSchema = z.object({
  slug: stringSchema.min(1),
  name: stringSchema.nullish(),
  colour: stringSchema.nullish(),
  logoUrl: stringSchema.nullish(),
  bannerTitle: stringSchema.nullish(),
  bannerBody: stringSchema.nullish(),
  bannerCta: stringSchema.nullish(),
  hideFromDefault: z.boolean().default(false),
})

export type StorefrontView = z.infer<typeof storefrontViewSchema>

export const mapStorefrontView = (item: Record<string, any>) => ({
  slug: item.data?.slug,
  name: item.data?.name,
  colour: item.data?.colour,
  logoUrl: item.data?.logo_url,
  bannerTitle: item.data?.banner_title,
  bannerBody: item.data?.banner_body,
  bannerCta: item.data?.banner_cta,
  hideFromDefault: !!item.data?.hide_from_default,
})
